import React from 'react';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { NavBarWrapper } from '@lessonnine/design-system.lib';
import { getIndexPageURL } from 'src/dataLayer/env';

export default () => {
  const { locale } = useRouteParamsContext();

  return (
    <NavBarWrapper logoUrl={ getIndexPageURL(locale) } />
  );
};
